import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, RacetrackData } from "@/types";

export const allUserSettingsQueryKey = ["user-settings", "all"] as const;

// The current user's racetrack show/hide preference.
export function useGetAllUserSettings() {
  return useQuery({
    queryKey: allUserSettingsQueryKey,
    queryFn: async () => {
      const path = "user-settings/racetrack-selections";
      const res = await guacHttpClient.get<
        RacetrackData,
        HttpResponse<RacetrackData>
      >(path);
      return res.data;
    },
  });
}
